var _path, _g, _g2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNewsHeroo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1920,
    height: 439,
    viewBox: "0 0 1920 439",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4815_20639)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_4815_20639",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: -383,
    y: -109,
    width: 2637,
    height: 419
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M-125.449 214.086L-374.085 306.717C-379.036 308.562 -383.782 303.569 -381.689 298.718L-207.748 -104.417C-206.799 -106.616 -204.634 -108.04 -202.239 -108.04H2247.46C2250.78 -108.04 2253.46 -105.354 2253.46 -102.04V209.815C2253.46 212.183 2252.07 214.33 2249.91 215.295L2042.3 307.86C2038.33 309.63 2033.85 306.725 2033.85 302.38V222.228C2033.85 218.077 2029.74 215.18 2025.83 216.579L1768.19 308.755C1764.29 310.153 1760.17 307.257 1760.17 303.106V219.709C1760.17 216.395 1757.49 213.709 1754.17 213.709H1617.59H1542.77H1354.17C1353.63 213.709 1353.1 213.78 1352.59 213.921L1002.61 309.553C998.79 310.596 995.026 307.723 995.026 303.766V219.709C995.026 216.395 992.339 213.709 989.026 213.709H545.305C544.626 213.709 543.953 213.824 543.314 214.049L273.89 308.814C269.987 310.187 265.899 307.291 265.899 303.154V219.709C265.899 216.395 263.213 213.709 259.899 213.709H-123.354C-124.07 213.709 -124.779 213.837 -125.449 214.086Z",
    fill: "#F9F9F9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_4815_20639)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -0.453125,
    y: -108.07,
    width: 1934.97,
    height: 478.695,
    fill: "url(#paint0_linear_4815_20639)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1921.7 155.727V370.625H0.664062V179.181C3.07677 178.443 9.78088 176.802 17.2957 176.142C26.6892 175.317 35.4569 173.667 44.8505 170.78C54.244 167.892 58.6271 170.367 84.9289 168.305C111.231 166.243 106.221 168.305 114.362 165.005C122.503 161.706 133.149 154.281 145.674 151.394C158.199 148.507 168.845 149.332 178.865 148.094C188.885 146.857 202.662 143.145 218.318 138.195C233.974 133.246 247.124 140.258 259.649 140.258C272.174 140.258 282.193 145.207 301.607 154.281C321.02 163.355 332.293 162.118 349.201 168.305C366.109 174.492 386.775 166.655 400.552 162.118C414.329 157.581 429.985 150.157 456.913 140.258C483.841 130.359 555.232 101.074 567.13 94.8671C579.029 88.6602 586.544 85.4005 591.553 85.4005C596.563 85.4005 620.36 94.8671 623.491 101.074C626.593 107.222 647.512 115.586 667.383 123.531L667.954 123.759C687.994 131.772 701.771 121.697 708.033 115.746C714.295 109.796 735.588 103.136 749.991 101.074C764.395 99.0117 824.682 64.6079 830.768 63.9913C835.637 63.4979 840.288 57.0021 842.005 53.8159C846.374 55.4604 855.581 58.9961 857.454 59.9828C859.794 61.2161 870.562 68.4737 881.33 68.4737H890.692C893.969 70.063 902.115 73.4883 908.482 74.475C914.849 75.4617 926.429 72.8905 931.422 71.4815L960.448 53.8159C967.782 50.4241 984.043 43.4555 990.41 42.7155C998.368 41.7904 1021.31 30.3818 1022.71 27.6067C1024.12 24.8316 1036.01 16.6893 1039.56 18.6938C1043.11 20.6984 1077.61 35.0658 1084.2 37.4044C1090.79 39.7431 1102.97 45.087 1110.07 50.0984C1117.17 55.1098 1124.78 66.1351 1138.98 68.4737C1153.19 70.8124 1220.65 98.8762 1242.46 107.897C1264.27 116.917 1271.88 115.746 1284.56 115.746C1297.24 115.746 1306.88 113.054 1319.06 107.897C1331.23 102.739 1369.78 97.8739 1388.55 94.8671C1407.32 91.8602 1422.03 79.8339 1440.8 71.4815C1459.57 63.1292 1478.1 74.9966 1482.19 77.3032C1486.28 79.6097 1642.7 113.054 1667.22 115.746C1691.73 118.439 1704.57 118.051 1713.33 115.746C1722.08 113.442 1739.01 113.054 1744.85 113.054C1750.68 113.054 1775.2 114.591 1794.46 118.051C1813.72 121.511 1830.07 130.739 1835.9 133.045C1841.74 135.352 1865.09 141.119 1875.59 145.732C1884 149.423 1909.84 153.933 1921.7 155.727Z",
    fill: "#5C7061",
    fillOpacity: 0.3
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.42
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("rect", {
    x: 1606.93,
    y: 232.264,
    width: 107.562,
    height: 134.102,
    fill: "#CFCFCF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1490.49,
    y: 232.264,
    width: 107.562,
    height: 134.102,
    fill: "#CFCFCF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1374.05,
    y: 232.264,
    width: 107.562,
    height: 134.102,
    fill: "#CFCFCF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1374.05,
    y: 373.723,
    width: 342.316,
    height: 226.362,
    fill: "#CFCFCF",
    fillOpacity: 0.6
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("rect", {
    x: 835.742,
    y: 232.264,
    width: 107.562,
    height: 134.102,
    rx: 5,
    fill: "#CFCFCF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 719.305,
    y: 232.264,
    width: 107.562,
    height: 134.102,
    rx: 5,
    fill: "#CFCFCF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 602.871,
    y: 232.264,
    width: 107.562,
    height: 134.102,
    rx: 5,
    fill: "#CFCFCF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 602.871,
    y: 373.723,
    width: 342.316,
    height: 226.362,
    rx: 5,
    fill: "#CFCFCF",
    fillOpacity: 0.6
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("rect", {
    x: 107.281,
    y: 232.264,
    width: 107.562,
    height: 134.102,
    fill: "#CFCFCF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: -9.15625,
    y: 232.264,
    width: 107.562,
    height: 134.102,
    fill: "#CFCFCF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: -125.594,
    y: 373.723,
    width: 342.316,
    height: 226.362,
    fill: "#CFCFCF",
    fillOpacity: 0.6
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4815_20639",
    x1: 967.034,
    y1: -108.07,
    x2: 967.034,
    y2: 370.625,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#121E1A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.715,
    stopColor: "#506D64"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4815_20639"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1920,
    height: 438.085,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewsHeroo);
export default __webpack_public_path__ + "static/media/news_heroo.c585c9ba789efadb0864d3662209b449.svg";
export { ForwardRef as ReactComponent };